import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'Journey North'
        }
    },
    {
        path: '/about',
        name: 'about',
        meta: {
            title: 'About Journey North'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'about' */ '../views/About.vue')
        }
    },
    {
        path: '/contact',
        name: 'contact',
        meta: {
            title: 'Contact Journey North'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'about' */ '../views/Contact.vue')
        }
    },
    {
        path: '/request-data',
        name: 'requestData',
        meta: {
            title: 'Request Data'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'about' */ '../views/DataRequest.vue')
        }
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - Journey North'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'login' */ '../views/Login.vue')
        }
    },
    {
        path: '/password/reset',
        name: 'passwordReset',
        component: function() {
            //prettier-ignore
            return import(/* webpackChunkName: 'passwordReset' */ '../views/PasswordReset.vue')
        }
    },
    {
        path: '/password/new/:token',
        name: 'passwordNew',
        component: function() {
            //prettier-ignore
            return import(/* webpackChunkName: 'passwordNew' */ '../views/PasswordNew.vue')
        }
    },
    {
        path: '/password/update',
        name: 'passwordUpdate',
        component: function() {
            //prettier-ignore
            return import(/* webpackChunkName: 'passwordUpdate' */ '../views/PasswordUpdate.vue')
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/profile/update',
        name: 'profileUpdate',
        component: function() {
            //prettier-ignore
            return import(/* webpackChunkName: 'profileUpdate' */ '../views/ProfileUpdate.vue')
        },
        meta: {
            title: 'Update Profile - Journey North',
            requiresAuth: true
        }
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            title: 'Become a Citizen Scientist - Journey North'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'login' */ '../views/RegisterUser.vue')
        }
    },
    {
        path: '/report',
        name: 'report',
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'report' */ '../views/ReportSighting.vue')
        },
        meta: {
            title: 'Report a Sighting - Journey North',
            requiresAuth: true
        }
    },
    {
        path: '/sightings',
        name: 'sightings',
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'sightings' */ '../views/Sightings.vue')
        },
        meta: {
            title: 'My Sightings - Journey North',
            requiresAuth: true
        }
    },
    {
        path: '/sightings/all',
        name: 'sightingsAll',
        meta: {
            title: 'Explore Data - Journey North'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'sightingsAll' */ '../views/SightingsAll.vue')
        }
    },
    {
        path: '/sightings/:projectKeyword',
        name: 'sightingsFiltered',
        meta: {
            title: 'Explore Data - Journey North'
        },
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'sightingsAll' */ '../views/SightingsAll.vue')
        }
    },
    {
        path: '/sighting/:id',
        name: 'sighting',
        component: function() {
            // prettier-ignore
            return import(/* webpackChunkName: 'sighting' */ '../views/Sighting.vue')
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.title)

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.metaTags)
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(
        document.querySelectorAll('[data-vue-router-controlled]')
    ).map(el => el.parentNode.removeChild(el))

    // Skip rendering meta tags if there are none.
    // Code we borrowed used the following, but that would exit before handling requiresAuth
    // if (!nearestWithMeta) return next()

    // Turn the meta tag definitions into actual elements in the head.
    if (nearestWithMeta) {
        nearestWithMeta.meta.metaTags
            .map(tagDef => {
                const tag = document.createElement('meta')

                Object.keys(tagDef).forEach(key => {
                    tag.setAttribute(key, tagDef[key])
                })

                // We use this to track which meta tags we create, so we don't interfere with other ones.
                tag.setAttribute('data-vue-router-controlled', '')

                return tag
            })
            // Add the meta tags to the document head.
            .forEach(tag => document.head.appendChild(tag))
    }

    const loggedIn = !!localStorage.getItem('user')

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn) {
            next({
                path: '/login'
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
